<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <modal :open="open" @close="close()">
    <template v-slot:modelcontent>
      <div>
        <div class="w-40 ring-2 ring-offset-2 ring-black m-auto" v-html="qrcode">
        </div>
        <div class="mt-3 text-center sm:mt-5">
          <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> {{ propertyname }}</DialogTitle>
          <div class="mt-5">
            <input type="text" id="qr-link" @click="copyLink" :value="qrcodelink"
                   class="appearance-none shadow-sm rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary focus:z-10 sm:text-sm">
            <p class="text-uknar-primary text-xs italic" v-if="hasCopiedLink">
              Copied Link
            </p>
          </div>
        </div>
      </div>
      <div class="mt-5 mb-2 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <button
            v-if="canpurchase == 1"
            type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                v-on:click="close('purchase')" ref="cancelButtonRef">Buy
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {CheckIcon} from '@heroicons/vue/outline'

export default {
  props: {
    open: {
      type: Boolean,
      required: true,
      default: true
    },
    propertyname: {
      type: String,
      required: true
    },
    qrcode: {
      type: String,
      required: true
    },
    qrcodelink: {
      type: String,
      required: true
    },
    canpurchase: {
      type: String,
      required: true,
      default: false
    },
  },
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckIcon,
  },
  data: function () {
    return {
      hasCopiedLink: false
    };
  },
  methods: {
    close: function (type = '') {
      this.$emit('closed', type);
    },
    copyLink: function () {
      var self = this;

      self.hasCopiedLink = true;

      if (navigator.clipboard) {

        navigator.clipboard.writeText(self.qrcodelink);

      } else {

        var text = self.qrcodelink;
        var input = document.getElementById('qr-link');

        input.select();
        input.focus();

        var result = document.execCommand('copy');

      }

      setTimeout(function () {

        self.hasCopiedLink = false;

      }, 2000);
    }
  }
}
</script>
